import {Avatar} from 'src/design/atoms/Avatar';
import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {InspectionAssigneeCandidateResponse} from 'src/api/ProactApiClient';
import {Button} from 'src/design/atoms/Button';

export interface AssignCandidateRowProps {
  candidate: InspectionAssigneeCandidateResponse;
  onAssign: (candidate: InspectionAssigneeCandidateResponse) => void;
  loading?: boolean;
  actionLabel?: string;
}

// Candidate endpoint returns no avatar `src` — Mantine's built-in initials
// fallback (`color="initials"`) covers it without needing `ProfileAvatar`.
export const AssignCandidateRow: React.FC<AssignCandidateRowProps> = ({
  candidate,
  onAssign,
  loading,
  actionLabel = 'Assign',
}) => (
  <Group justify="space-between" wrap="nowrap" py="xs">
    <Group gap="sm" wrap="nowrap">
      <Avatar name={candidate.name} color="initials" radius="xl" />
      <div>
        <Text size="sm" fw={500}>
          {candidate.name}
        </Text>
        <Text size="xs" c="dimmed">
          {candidate.openInspectionCount} active
        </Text>
      </div>
    </Group>

    <Button
      size="xs"
      variant="subtle"
      loading={loading}
      onClick={() => onAssign(candidate)}>
      {actionLabel}
    </Button>
  </Group>
);
